import React, { type PropsWithChildren, type ReactNode } from 'react';
import { Box, Flex, Heading, useTheme } from '@chakra-ui/react';
import { useBreakpoint } from 'ts/common/hooks';

interface Props {
    banner: ReactNode;
    headingRightContent?: ReactNode;
    headingText: string;
}

const ClientPageLayout = ({
    banner,
    children,
    headingRightContent,
    headingText
}: PropsWithChildren<Props>) => {
    const isLargeScreen = useBreakpoint();
    const theme = useTheme();

    return (
        <Box
            alignSelf="flex-start"
            bg={{ base: 'paper', lg: 'paperBackground' }}
            color="var(--chakra-colors-text)"
            minHeight="100%"
            width="100%"
        >
            <Flex
                width="100%"
                height={{ base: '50px', lg: '80px' }}
                backgroundColor="paper"
                alignItems="center"
                justifyContent="space-between"
                paddingLeft="16px"
                paddingRight="16px"
                boxSizing="border-box"
            >
                <Heading as="h2" size="sm" color="brand.primary" margin={0}>
                    {headingText}
                </Heading>
                {isLargeScreen ? headingRightContent : undefined}
            </Flex>
            <Flex
                width="100%"
                height={isLargeScreen ? '300px' : '200px'}
                marginX="auto"
                alignItems="center"
                justifyContent="center"
                overflow="hidden"
                flexDirection="column"
            >
                {banner}
            </Flex>
            <Box
                background="paper"
                borderRadius="20px"
                boxSizing="border-box"
                fontFamily={theme.fonts}
                position="relative"
                boxShadow={isLargeScreen ? '0px 4px 40px 0px rgba(0, 0, 0, 0.08)' : undefined}
                margin={isLargeScreen ? '0 auto 40px' : undefined}
                maxWidth={isLargeScreen ? '960px' : undefined}
                padding={isLargeScreen ? '40px 34px' : '16px 16px 96px 16px'}
                top={isLargeScreen ? '-52px' : undefined}
            >
                {children}
            </Box>
        </Box>
    );
};

export default ClientPageLayout;
